import {
    Image, KeyboardAvoidingView, ScrollView,
    StyleSheet,
    Text,
    TouchableOpacity,
    View
} from "react-native";
import React, { useEffect, useState } from "react";
import NavBar from "../../components/NavBar";
import {
    color_main,
    white,
    color_929292,
    transparent,
    black
} from "../../assets/style/colors";
import LinearGradient from "react-native-linear-gradient";
import { AuthNavProps } from "../navigation/auth/AuthParamList";
import { checkPhone, register } from "../../net/service";
import { showToast } from "../../components/Toast";
import { hideLoading, showLoading } from "../../components/Loading";
import { showDialog, showMsgDialog } from "../../components/CommonDialog";
import {
    Str_AccFormatErr,
    Str_AccNotNull, Str_AlreadyRegistered, Str_CodeAlreadySend, Str_CodeNotNull, Str_CodeSendFail,
    Str_Err1015,
    Str_HasAcc,
    Str_InputAcc, Str_InputCode,
    Str_InputNick,
    Str_InputPhone,
    Str_InputPsd,
    Str_InputPsdAgain,
    Str_LoginNow,
    Str_NickNotNull,
    Str_PhoneFormatErr, Str_PhoneNotNull,
    Str_PsdFormatErr,
    Str_PsdInconsistent,
    Str_PsdLengthErr1,
    Str_PsdLengthErr2,
    Str_PsdNotNull,
    Str_Register,
    Str_RegisterFail,
    Str_Registering,
    Str_RegisterSuc, Str_ReSend, Str_SendCode
} from "../../language/string_res";
import DeviceInfo from 'react-native-device-info';
import { ButtonView } from "../../components/ButtonView";
import { CryptEngine } from "../../utils/CryptEngine";
import { getLanguage } from "../../language/i18n";
import { CommonInput } from "./CommonInput";
import { ChangeLanguageModal } from "../setting/other_setting";
import { ImageView } from "../../components/ImageView";

export function isNumeric(str: string) {
    return /^\d+$/.test(str);
}

export function isValidEmail(email: string) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
}
export function accValidate(input: string): boolean {
    const regex = /^[a-zA-Z0-9_]+$/;
    return regex.test(input);
}

export function validatePassword(pad: string): boolean {
    //至少一个特殊符号， 
    let count = 0
    //数字
    const numberRegex = /\d+/;
    const isConstNumber = numberRegex.test(pad);
    if (isConstNumber) {
        count++
    }
    //小写字母 
    const lowerRegex = /[a-z]+/;
    const isLower = lowerRegex.test(pad);
    if (isLower) {
        count++
    }
    //大写字母 
    const lcapitalRegex = /[A-Z]+/;
    const isCapital = lcapitalRegex.test(pad);
    if (isCapital) {
        count++
    }
    //特殊字符
    // const regex = /[^\w]+/;
    // if (regex.test(pad)) {
    //     count++
    // }
    return count >= 3;
}

// let totalTime = 60
// let timeout: any = undefined
// export const Register = ({ navigation, route }: AuthNavProps<"Register">) => {
//     const [account, setAccount] = useState("");
//     const [phone, setPhone] = useState("");
//     const [code, setCode] = useState('')
//     const [psd, setPsd] = useState("");
//     const [psdAgain, setPsdAgain] = useState("");
//     const [name, setNike] = useState("");
//     const vcode = route.params.vcode;
//     const [running, setRunning] = useState(false)
//     const [sendText, setSendText] = useState(Str_SendCode)
//     const language = getLanguage()
//     const [countryCode, setCountryCode] = useState("+86");
//     const [countryVisible, setCountryVisible] = useState(false);

//     useEffect(() => {
//         const code = getLanguage()
//         let countryCode = '+86'
//         if (code === 'es') {
//             countryCode = '+34'
//         } else if (code === 'ja') {
//             countryCode = '+81'
//         } else if (code === 'vi') {
//             countryCode = '+84'
//         } else if (code === 'pt') {
//             countryCode = '+351'
//         } else if (code === 'en') {
//             countryCode = '+1'
//         }
//         setCountryCode(countryCode)
//     }, [])
//     const navigationToLogin = () => {
//         navigation.goBack();
//     };

//     function startTime() {
//         setRunning(true)
//         totalTime = 60
//         setSendText(`${totalTime}s`)
//         timeout = setInterval(() => {
//             --totalTime
//             if (totalTime <= 0) {
//                 reset()
//             } else {
//                 setSendText(`${totalTime}s`)
//             }
//         }, 1000);
//     }

//     function reset() {
//         setSendText(Str_ReSend)
//         setRunning(false)
//         clearInterval(timeout)
//     }

//     const sendCode = () => {
//         function code() {
//             const sign = CryptEngine.md5(`${countryCode}-${phone}|10|${language}|fuliao`)
//             const body = {
//                 phone: `${countryCode}-${phone}`,
//                 send_type: "10",
//                 sign: sign,
//                 lang: language,
//             }
//             sendPhoneCode(body).then(res => {
//                 if (res.code === 0) {
//                     showToast(Str_CodeAlreadySend)
//                 } else {
//                     showToast(res.msg || Str_CodeSendFail)
//                     reset()
//                 }
//             })
//         }

//         if (running) {
//             return;
//         }
//         if (!phone || phone.trim().length <= 0) {
//             showToast(Str_PhoneNotNull)
//             return
//         }
//         startTime()
//         checkPhone(`${countryCode}-${phone}`, vcode, language).then(res => {
//             if (res.code === 0) {
//                 if (res.data && res.data.exist !== true) {
//                     code()
//                 } else {
//                     showToast(Str_AlreadyRegistered)
//                     reset()
//                 }
//             } else {
//                 showToast(res.msg ?? '')
//                 reset()
//             }
//         })
//     }
//     //注册
//     const Register = async () => {
//         if (name.trim().length <= 0) {
//             showToast(Str_NickNotNull)
//             return
//         }
//         if (account.trim().length <= 0) {
//             showToast(Str_AccNotNull)
//             return
//         }

//         if (!accValidate(account)) {
//             showToast(Str_AccFormatErr)
//             return
//         }

//         if (psd.trim().length <= 0) {
//             showToast(Str_PsdNotNull)
//             return
//         }

//         if (psd.trim().length < 8) {
//             showToast(Str_PsdLengthErr1)
//             return
//         }
//         if (psd.trim().length > 32) {
//             showToast(Str_PsdLengthErr2)
//             return
//         }
//         if (!validatePassword(psd)) {
//             showToast(Str_PsdFormatErr)
//             return
//         }
//         if (psd.trim() !== psdAgain.trim()) {
//             showToast(Str_PsdInconsistent)
//             return
//         }
//         if (!isNumeric(phone.trim())) {
//             showToast(Str_PhoneFormatErr)
//             return
//         }
//         if (code.trim().length <= 0) {
//             showToast(Str_CodeNotNull)
//             return
//         }
//         // if (email.length > 0 && !isValidEmail(email.trim())) {
//         //     showToast(Str_EmailFormatErr)
//         //     return
//         // }
//         showLoading(Str_Registering)
//         const r = await checkCode({ phone: `${countryCode}-${phone}`, send_type: "10", code: code, lang: language })
//         if (r.code !== 0 || !r.data) {
//             showToast(r.msg ?? Str_Err1015)
//             hideLoading()
//             return
//         }
//         const token = r.data.sms_token
//         const enginePsd = CryptEngine.base64Encode(psd.trim())
//         const deviceId = await DeviceInfo.getUniqueId()
//         register({
//             name: name,
//             telno: `${countryCode}-${phone}`,
//             email: account,
//             passwd1: enginePsd,
//             passwd2: enginePsd,
//             pre_email: '',
//             pre_tel: '',
//             aggrement: true,
//             lang: getLanguage(),
//             deviceId: deviceId,
//             vcode: vcode,
//             sms_token: token
//         }
//         ).then((data: any) => {
//             if (data.code !== 0) {
//                 showMsgDialog(data.msg || Str_RegisterFail);
//             } else {
//                 showDialog({
//                     message: Str_RegisterSuc,
//                     onConfirm: () => {
//                         navigation.navigate('OpenSecurity', {
//                             from: 'register',
//                             psd: psd,
//                             account: account,
//                             vcode: vcode
//                         })
//                     }
//                 });
//             }

//         }).finally(() => {
//             hideLoading()
//         });
//     };
//     const onAccChangeText = (text: string) => {
//         if (text.length > 0 && !accValidate(text)) {
//             showToast(Str_AccFormatErr)
//         }
//         setAccount(text)
//     }
//     return (<View style={{ flex: 1, backgroundColor: white }}>
//         <View style={{
//             paddingTop: 126,
//             display: 'flex',
//             flexDirection: 'row',
//             justifyContent: 'center',
//         }}>
//             <Image source={require("../../assets/image/icon_service_number.png")} style={{ width: 258, height: 75, objectFit: 'contain' }} />
//         </View>
//         <KeyboardAvoidingView
//             behavior={'padding'}
//             style={{
//                 width: '100%',
//                 position: 'absolute',
//                 top: getScreenHeight() * 0.28,
//                 bottom: 0,
//             }}>
//             <ScrollView
//                 contentContainerStyle={{
//                     flexGrow: 1,
//                     justifyContent: 'center',
//                     alignItems: 'center',
//                 }}>
//                 <View style={{ paddingHorizontal: 28, width: '100%' }}>
//                     {/*输入框*/}
//                     <CommonInput
//                         isRequired={true}
//                         source={require("../../assets/image/icon_nickname.png")}
//                         placeholder={Str_InputNick}
//                         text={name}
//                         maxLength={16}
//                         onChangeText={setNike} />

//                     <CommonInput
//                         isRequired={true}
//                         style={{ marginTop: 12 }}
//                         source={require("../../assets/image/icon_account.png")}
//                         placeholder={Str_InputAcc}
//                         text={account}
//                         onChangeText={onAccChangeText} />

//                     <CommonInput
//                         isRequired={true}
//                         style={{ marginTop: 12 }}
//                         source={require("../../assets/image/icon_phone.png")}
//                         placeholder={Str_InputPhone}
//                         text={phone}
//                         keyboardType={'phone-pad'}
//                         sendText={countryCode}
//                         sendCode={() => { setCountryVisible(true) }}
//                         onChangeText={setPhone} />

//                     <CommonInput
//                         isRequired={true}
//                         style={{ marginTop: 12 }}
//                         placeholder={Str_InputCode}
//                         text={code}
//                         onChangeText={setCode}
//                         sendText={sendText}
//                         sendCode={sendCode}
//                         keyboardType={'numeric'}
//                         source={require('../../assets/image/icon_psd.png')} />

//                     <CommonInput
//                         isRequired={true}
//                         style={{ marginTop: 12 }}
//                         source={require("../../assets/image/icon_psd.png")}
//                         placeholder={Str_InputPsd}
//                         text={psd}
//                         secureTextEntry={true}
//                         onChangeText={setPsd} />

//                     <CommonInput
//                         isRequired={true}
//                         style={{ marginTop: 12 }}
//                         source={require("../../assets/image/icon_psd.png")}
//                         placeholder={Str_InputPsdAgain}
//                         text={psdAgain}
//                         secureTextEntry={true}
//                         onChangeText={setPsdAgain} />

//                     {/*登录注册*/}
//                     <TouchableOpacity onPress={Register}>
//                         <LinearGradient
//                             colors={["#5F9AC2", "#5F9AC2"]}
//                             start={{ x: 0, y: 0 }} end={{ x: 1, y: 0 }}
//                             style={styles.button}>
//                             <Text style={{
//                                 color: white,
//                                 fontSize: 16,
//                                 width: '100%',
//                                 textAlign: 'center',
//                                 fontFamily: '',
//                                 fontWeight: "bold"
//                             }}>{Str_Register}</Text>
//                         </LinearGradient>
//                     </TouchableOpacity>
//                     <View style={styles.registerContainer}>
//                         <Text style={{ color: color_929292, fontSize: 14 }}>{Str_HasAcc}</Text>
//                         <ButtonView
//                             onPress={navigationToLogin}
//                             textStyle={{
//                                 color: '#5F9AC2',
//                                 fontSize: 14,
//                                 textDecorationLine: "underline"
//                             }}
//                             text={Str_LoginNow} />
//                     </View>
//                 </View>
//             </ScrollView>
//         </KeyboardAvoidingView>
//         <NavBar showBack={true} style={styles.back} />

//     </View>);

// };
// const screenWidth = getScreenWidth()
// const height = screenWidth / 375 * 421.5
// const styles = StyleSheet.create({
//     image: { width: "100%", height: '100%' },
//     back: {
//         position: "absolute",
//         backgroundColor: transparent,
//         top: 50,
//         left: 0,
//         right: 0
//     },
//     button: {
//         paddingVertical: 15,
//         alignItems: "center",
//         borderRadius: 30,
//         marginTop: 40
//     },

//     registerContainer: {
//         justifyContent: "center",
//         padding: 10,
//         marginTop: 10,
//         flexDirection: "row",
//         alignItems: "center"
//     }

// });
